import { CompaniesList } from '@Resources/companies/CompaniesList';
import { CompaniesShow } from '@Resources/companies/CompaniesShow';
import { ResourceDefinition } from '@Utils/types';

export const companiesResource: ResourceDefinition = {
  options: {
    label: 'menu.companies',
  },
  show: CompaniesShow,
  list: CompaniesList,
};
